export default class ClearCompositionStore {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.snippetComposition.remove();
  }
}
